import Cookies from "universal-cookie";
import { refreshTokenWithRequest } from "../_api/usersApi";

const cookies = new Cookies();

const getAccessToken = (data) =>
  typeof data === "string"
    ? data
    : data?.jwtToken || data?.JWTToken || data?.token || data?.accessToken;

const getRefreshToken = (data) => data?.refreshToken || data?.RefreshToken;

export async function refreshEnrolleeToken() {
  const enrolleeUser = cookies.get("lifesaferEnrollment");
  const currentToken = getAccessToken(enrolleeUser);
  const currentRefreshToken = getRefreshToken(enrolleeUser);

  if (!currentToken) return enrolleeUser;
  if (!currentRefreshToken) {
    throw new Error("The enrollee refresh token is missing.");
  }

  const refreshResponse = await refreshTokenWithRequest(
    currentToken,
    currentRefreshToken,
  );
  const refreshedToken = getAccessToken(refreshResponse);
  const refreshedRefreshToken = getRefreshToken(refreshResponse);

  if (!refreshedToken) {
    throw new Error("Token refresh response did not include a JWT token.");
  }
  if (!refreshedRefreshToken) {
    throw new Error("Token refresh response did not include a refresh token.");
  }

  const refreshedData =
    refreshResponse && typeof refreshResponse === "object"
      ? refreshResponse
      : {};
  const updatedEnrollee = {
    ...enrolleeUser,
    ...refreshedData,
    jwtToken: refreshedToken,
    JWTToken: refreshedToken,
    refreshToken: refreshedRefreshToken,
    RefreshToken: refreshedRefreshToken,
  };

  cookies.set("lifesaferEnrollment", JSON.stringify(updatedEnrollee), {
    path: "/",
    sameSite: "strict",
  });

  if (typeof sessionStorage !== "undefined") {
    const storedEnrollee = sessionStorage.getItem("enrolleeUser");

    if (storedEnrollee) {
      try {
        const sessionEnrollee = JSON.parse(storedEnrollee);
        sessionStorage.setItem(
          "enrolleeUser",
          JSON.stringify({
            ...sessionEnrollee,
            jwtToken: refreshedToken,
            JWTToken: refreshedToken,
            refreshToken: refreshedRefreshToken,
            RefreshToken: refreshedRefreshToken,
          }),
        );
      } catch (error) {
        console.error("Unable to update enrollee tokens in session storage.", error);
      }
    }
  }

  return updatedEnrollee;
}
